module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/fe957fe9b9c1d263b3482979476321a8.png";